import React from 'react';

import JobProspectsStatsDetailLoader from './JobProspectsStatsDetailLoader';
import { useJobProspectsStatsState, useJobProspectsStatsActions } from './JobProspectsStatsContext';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import { scheduleJobProspectCreation } from './restApi';
import styles from './JobProspectsStatsDetail.module.scss';

const JobProspectsStatsDetail = () => {
  const state = useJobProspectsStatsState();
  const { onResponse, onError } = useJobProspectsStatsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleScheduleJobProspects = () => {
    scheduleJobProspectCreation({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <>
      <JobProspectsStatsDetailLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text="Job Prospects Statistics" />
          <div style={{ marginBottom: '1rem' }}>
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats'}
            >
              ← Back to Stats Overview
            </Button>
          </div>
          
          {state?.loading && <p>Loading...</p>}
          
          {state?.feedbackVariant === 'error' && (
            <p style={{ color: 'red' }}>Error: {state?.feedbackMessage}</p>
          )}
          
          {!state?.loading && state?.feedbackVariant !== 'error' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <p><strong>Total Job Prospects:</strong> {state?.total}</p>
              <hr />
              <p><strong>Awaiting Admin Approval:</strong> {state?.awaiting_admin_approval}</p>
              <p><strong>Not Started:</strong> {state?.not_started}</p>
              <p><strong>Application In Process:</strong> {state?.application_in_process}</p>
              <p><strong>Applied and Waiting:</strong> {state?.applied_and_waiting}</p>
              <p><strong>Interviewing:</strong> {state?.interviewing}</p>
              <p><strong>Offer Received:</strong> {state?.offer_received}</p>
              <p><strong>Offer Accepted:</strong> {state?.offer_accepted}</p>
              <p><strong>Not Hiring:</strong> {state?.not_hiring}</p>
              <p><strong>No Offer:</strong> {state?.no_offer}</p>
              <p><strong>Decided Against:</strong> {state?.decided_against}</p>
              <p><strong>Waiting for Decision:</strong> {state?.waiting_for_decision}</p>
            </div>
          )}
          
          <ActionRow>
            <Button onClick={handleScheduleJobProspects}>
              Schedule Job Prospect Creation
            </Button>
          </ActionRow>
        </Stack>
      </div>
    </>
  );
};

export default JobProspectsStatsDetail;
